const toBounded = (value: number, bounds: number[]) => {
  return Math.min(bounds[1], Math.max(bounds[0], value))
}

export default toBounded